import React, { Component } from 'react'
import { StaticBox, LinkedInput, LinkedInputGroup, LinkedTextArea, LinkedToggle } from 'components/basic'
import { FormHelper, notify } from 'helpers'
import Select from 'react-select'
import http from 'API/http'

class TicketCreator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ticket: {
        status: 'CREATED',
        responsible: 'CO',
        priority: 'None',
        description: '',
        createdBy: this.props.user.name,
        accessId: this.props.match.params.accessId,
        subscriptionId: this.props.match.params.service,
        problemType: 'OTHER',
        additionalInfo: {
          link: false,
          ip: '',
          mac: ''
        }
      }
    }
  }
  async create () {
    var valid = await FormHelper.validate(this.form)
    if (this.state.ticket.description.length === 0) return notify.warn('Ticket description is required')
    if (!valid) return

    var [err, res] = await http.post('2.4/tickets', this.state.ticket)

    if (err) return notify.warn(res.cause)
    notify.success('Ticket created!')
    window.location.hash = '/ticket/' + res.data.coTicketReference
  }
  render () {
    return (
      <StaticBox cols={12} icon='ticket' title='Create New Ticket' buttons={[
        { icon: 'fa-save', event: () => this.create() }
      ]}>
        <div className='row'>
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='col-md-3'>
              <label>Title</label>
              <LinkedInput context={this} path='ticket.heading' errorMessage='This field is required' validate={/\w{1,}/i} />
            </div>
          </LinkedInputGroup>
          <div className='col-md-3'>
            <label>Priority</label>
            <Select
              value={this.state.ticket.priority}
              onChange={e => this.setState({ticket: {...this.state.ticket, priority: e.value}})}
              options={[
                {
                  name: 'None',
                  value: 'None'
                },
                {
                  name: 'Minor',
                  value: 'Minor'
                },
                {
                  name: 'Medium',
                  value: 'Medium'
                },
                {
                  name: 'Major',
                  value: 'Major'
                },
                {
                  name: 'Critical',
                  value: 'Critical'
                }
              ]}
              valueKey='value'
              labelKey='name'
              clearable={false}
            />
          </div>
          <div className='col-md-3'>
            <label>Problem Type</label>
            <Select
              value={this.state.ticket.problemType}
              onChange={e => this.setState({ticket: {...this.state.ticket, problemType: e.value}})}
              options={[
                {
                  name: 'NO_LINK',
                  value: 'NO_LINK'
                },
                {
                  name: 'NO_ACCESS',
                  value: 'NO_ACCESS'
                },
                {
                  name: 'QUALITY',
                  value: 'QUALITY'
                },
                {
                  name: 'OTHER',
                  value: 'OTHER'
                }
              ]}
              valueKey='value'
              labelKey='name'
              clearable={false}
            />
          </div>
          <div className='col-md-3'>
            <label>Responsible</label>
            <Select
              value={this.state.ticket.responsible}
              onChange={e => this.setState({ticket: {...this.state.ticket, responsible: e.value}})}
              options={[
                {
                  name: 'CO',
                  value: 'CO'
                },
                {
                  name: 'SP',
                  value: 'SP'
                }
              ]}
              valueKey='value'
              labelKey='name'
              clearable={false}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>Your Internal Reference</label>
            <LinkedInput context={this} path='ticket.spReference' />
          </div>
          <div className='col-md-3'>
            <label>MAC-Address</label>
            <LinkedInput context={this} path='ticket.additionalInfo.mac' />
          </div>
          <div className='col-md-3'>
            <label>IP-Address</label>
            <LinkedInput context={this} path='ticket.additionalInfo.ip' />
          </div>
          <div className='col-md-3'>
            <label>Linkstatus</label>
            <LinkedToggle context={this} path='ticket.additionalInfo.link' name={(this.state.ticket.additionalInfo.link ? 'Up' : 'Down')} />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>Contact Info</label>
            <LinkedInput context={this} path='ticket.contactInfo' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <hr />
            <label>Description</label>
            <LinkedTextArea context={this} path='ticket.description' rows='5' />
          </div>
        </div>
      </StaticBox>
    )
  }
}
export default TicketCreator



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/ticket/TicketCreator.js